export default "__VITE_ASSET__CQqZVskW__"